import { render, staticRenderFns } from "./cardActivity.vue?vue&type=template&id=513f21b1&scoped=true"
import script from "./cardActivity.vue?vue&type=script&lang=js"
export * from "./cardActivity.vue?vue&type=script&lang=js"
import style0 from "./cardActivity.vue?vue&type=style&index=0&id=513f21b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513f21b1",
  null
  
)

export default component.exports